import Vue from "vue";
import Vuex from "vuex";
import fetchAPI from "@/mixins/fetchApi";
Vue.use(Vuex);
import { EventBus } from "../mixins/event-bus.js";
const UserStore = new Vuex.Store({
  state: {
    version: "0.1",
    init: false,
    logged: false,
    token: null,
    user_display_name: null,
    user_email: null,
    user_nicename: null,
    avatar: null,
    favorites: [],
    likes: [],
  },
  mutations: {
    async initialiseStore(state) {
      // Check if the store exists
      if (localStorage.getItem("userStore")) {
        let store = JSON.parse(localStorage.getItem("userStore"));
        // Check the version stored against current. If different, don't
        // load the cached version
        const validate = await fetchAPI.validateToken(store.token);
        if (store.version == state.version && validate.status == 200) {
          this.replaceState(Object.assign(state, store));
          fetchAPI.setAxiosHeaders();
        } else if (!store.logged) {
          this.replaceState(Object.assign(state, store));
        }
      }
      EventBus.$emit("userInit");
      state.init = true;
    },
    addToFavorites(state, recipeId) {
      if (!state.favorites.includes(recipeId)) {
        state.favorites.push(recipeId);
        Vue.set(state, "favorites", state.favorites);
        localStorage.setItem("userStore", JSON.stringify(state));
      }
    },
    removeFromFavorites(state, recipeId) {
      if (state.favorites.includes(recipeId)) {
        const newfavorites = state.favorites.filter(
          (favoriteId) => favoriteId !== recipeId
        );
        Vue.set(state, "favorites", newfavorites);
      }
      localStorage.setItem("userStore", JSON.stringify(state));
    },
    addToLikes(state, recipeId) {
      if (!state.likes.includes(recipeId)) {
        state.likes.push(recipeId);
        Vue.set(state, "likes", state.likes);
        localStorage.setItem("userStore", JSON.stringify(state));
      }
    },
    removeFromLikes(state, recipeId) {
      if (state.likes.includes(recipeId)) {
        const newlikes = state.likes.filter((likeId) => likeId !== recipeId);
        Vue.set(state, "likes", newlikes);
      }
      localStorage.setItem("userStore", JSON.stringify(state));
    },
    setUserData(state, value) {
      Vue.set(state, "token", value.token);
      Vue.set(state, "user_display_name", value.user_display_name);
      Vue.set(state, "user_email", value.user_email);
      Vue.set(state, "user_nicename", value.user_nicename);
      Vue.set(state, "user_id", value.user_id);
      Vue.set(state, "avatar", value.avatar);
      Vue.set(state, "favorites", value.favorites);
      Vue.set(state, "likes", value.likes);
      localStorage.setItem("userStore", JSON.stringify(state));
    },
    setLogged(state, value) {
      Vue.set(state, "logged", value);
    },
    signOut(state) {
      Vue.set(state, "logged", false);
      Vue.set(state, "token", null);
      Vue.set(state, "user_display_name", null);
      Vue.set(state, "user_email", null);
      Vue.set(state, "user_nicename", null);
      Vue.set(state, "user_id", null);
      Vue.set(state, "avatar", null);
      Vue.set(state, "favorites", []);
      Vue.set(state, "likes", []);
      localStorage.setItem("userStore", JSON.stringify(state));
    },
    saveLocalStorage(state) {
      localStorage.setItem("userStore", JSON.stringify(state));
    },
  },
  actions: {},
  modules: {},
});

// Check if user token is valid

export default UserStore;
